module.exports = __webpack_public_path__ + "img/plant-in-rocks.dc926ee5.webp";